import useMediaQuery from '@mui/material/useMediaQuery';
import Box from '@mui/material/Box';

import Search from './Search';
import Profile from './Profile';
import Notification from './Notification';

// ==============================|| HEADER - CONTENT ||============================== //

export default function HeaderContent() {
  const downMD = useMediaQuery((theme) => theme.breakpoints.down('md'));

  return (
    <>
      {!downMD && <Search />}
      <Box sx={{ flexGrow: 1 }} />
      <Notification />
      <Profile />
    </>
  );
}

